<template>
  <div class="border p-1 mb-2">
        <div class="d-flex justify-content-center">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-content-center">
              <h3><b-badge variant="secondary">{{ data.total }}</b-badge></h3>
            </div>
            <div class="d-flex flex-row justify-content-center">
              <p>{{ $t(data.name) }} </p>
            </div>

            <div class="d-flex flex-row justify-content-center">
              <vue-apex-charts :options="getDeviceChartOptions()" height="250px" width="60%" :series="[{
                name: $t('Working Engine'),
                data: [data.working],
                color:'#04d600'
              }, 
              {
                name: $t('Stopped Engine'),
                data: [data.stopped],
                color:'#FF1405'
              }, 
              {
                name: $t('Offline'),
                data: [data.offline],
                color:'#D6D5D5'
              }]"/>
              </div>
            
          </div>
        </div>

      </div>
</template>

<script>
import {
  BFormGroup, BCard, BCardHeader,
  BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside,
  BAvatar, BMediaBody, BLink, BContainer, BTable, BPagination, BFormSelect, BButton, VBTooltip,
  BProgress,
  BBadge
} from 'bootstrap-vue'

import TableWidget from './modals/TableWidget.vue';
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
import data from '@/router/routes/ui-elements';
export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    OrbitSpinner,
    TableWidget,
    VueApexCharts,
    BProgress,
    BBadge
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    }
  },

  setup(props, { root }) {

    const getDeviceChartOptions = () => {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        responsive: [],
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'center',
              total: {
                enabled: false,
                formatter: (v)=> {
                  return v
                },
                offsetX: 15,
                offsetY: 0
              }
            }
          },
        },
        yaxis:{
          show:false
        },
        xaxis: {
          type: 'category',
          categories: [''],
          position:'bottom',
          labels: {
            show: false,
            rotate:90,
            trim: true,
            style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400
            }
          },
          tooltip: {
            enabled: true,
            formatter: undefined,
            offsetY: 0,
            style: {
              fontSize: 0,
              fontFamily: 0,
            },
          },
        },
        legend: {
          show:false
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.2
          }
        }
      }
    }


    return { getDeviceChartOptions }
  }
}
</script>